export default __webpack_public_path__ + "static/media/amar.bbc778eb.jpg";